import { render, staticRenderFns } from "./Vendasfiliais.vue?vue&type=template&id=6b4ce5b5&"
import script from "./Vendasfiliais.vue?vue&type=script&lang=js&"
export * from "./Vendasfiliais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports